/*eslint-disable*/export const messages=JSON.parse("{\"icon.title.arrow-left\":[\"Leftward-pointing arrow\"]}");